export class MessageClass {
  constructor(text, sender, delay) {
		this.text = text;
		this.sender = sender;
		this.delay = delay;
  }
}


// WEBPACK FOOTER //
// src/classes/MessageClass.js